import {
  Box,
  Button,
  Card,
  CardBody,
  Input,
  InputGroup
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./reportCalendarComponent.css";

const ReportCalendarComponent = ({
  callbackFunctionDate,
  triggerSetter = null,
  date,
  height = "40px",
  swap = false,
  left
}) => {
  const [selectedDate, setSelectedDate] = useState(date);
  const [showPicker, setShowPicker] = useState(false);
  const datePickerRef = useRef();

  const handleDateSelection = (date) => {
    setSelectedDate(date);
  };

  const handleClickOutside = (event) => {
    if (
      datePickerRef.current &&
      !datePickerRef.current.contains(event.target)
    ) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSave = () => {
    callbackFunctionDate(selectedDate);
    triggerSetter && triggerSetter(true);
    setShowPicker(false);
  };

  const formatDisplayDate = () => {
    if (date instanceof Date && !isNaN(date)) {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();

      return `${month}/${day}/${year}`;
    } else {
      return "";
    }
  };

  return (
    <Box ref={datePickerRef} position="relative">
      <InputGroup
        width="100%"
        minWidth={"100px"}
        maxW={"150px"}
        textAlign={"center"}
        backgroundColor={"white"}
        borderRadius={"12px"}
      >
        <Input
          cursor={"pointer"}
          height={height}
          fontSize={"16px"}
          readOnly
          value={formatDisplayDate()}
          onClick={() => setShowPicker((prev) => !prev)}
        />
      </InputGroup>
      {showPicker && (
        <Card
          textAlign={"right"}
          p={0}
          zIndex={9999}
          width="290px"
          position="absolute"
          right={!swap && "0"}
          left={swap && ( left ? left : "0")}
          top="100%"
          backgroundColor="white"
          boxShadow="md"
        >
          <CardBody p={1}>
            <Box>
              <DatePicker
                selected={selectedDate}
                onChange={handleDateSelection}
                inline
                dateFormat="dd/MM/yyyy"
              />
              <Button
                m={"6px 9px 10px"}
                height={"32px"}
                width={"81px"}
                backgroundColor="#536DEC"
                textColor={"white"}
                onClick={handleSave}
              >
                Save
              </Button>
            </Box>
          </CardBody>
        </Card>
      )}
    </Box>
  );
};

export default ReportCalendarComponent;
